import {AppHelper} from "../../appHelper";
import {Grid} from "../../core/components/grid";
import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import {ExecutionInfoItem, ExecutionState} from "./recurringTaskHistory";
import {NotificationHelper} from "../../core/util/notificationHelper";
import {Helper} from "../../core/util/helper";
import {DialogHelper} from "../../core/util/dialogHelper";
import {Config} from "../../core/config/config";
import ExecutionDialog from "./executionDialog";
import AssignmentsGridApp from "./assignmentGrid";
import {ExecutionFilter} from "./executions";
import { GridCustomToolBarButton } from "../../core/components/toolBar";
import { Entity } from "../../core/components/commonApp";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class ExecutionsGridApp extends React.Component<ExecutionsGridAppProps, ExecutionsAppState>
{
    private cancelDialogRef: ExecutionDialog;
    private rescheduleDialogRef: ExecutionDialog;
    private finishDialogRef: ExecutionDialog;
    executionGridOptions: {};
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;

    constructor(props) {
        super(props);
        this.common.init(this);
        this.state = {
            executionsGridData: this.getGridData(),
            DialogText: "",
            tasksToTriggerCount: 0,
            selectedExecutions: [],
            selectedExecutionInfos: []
        }
        this.executionGridOptions = this.props.context.executionGridOptions;
    }

    private getGridData = () => {
        if (Helper.hasValue(this.props.gridData))
            return this.props.gridData;
        else
            return [];
    }

    getExecutionInfos = async (executionIds: string[]) => {
        let result = await HTTPService.post<JsonResultClass<ExecutionInfoItem[]>>("Executions/GetExecutionInfoItems", executionIds);
        if (result.Code === 0) {
            return result.Data;
        }
        else NotificationHelper.showErrorMessage(result.Message);
        return [];
    }

    setExecutionInfos = async (filter: ExecutionFilter) => {
        let result = await HTTPService.post<JsonResultClass<ExecutionInfos>>("Executions/GetExecutionInfos", filter);
        if (result.Code == 0) {
            let executionInfos = result.Data;
            this.setState({ executionsGridData: executionInfos.ExecutionInfos, tasksToTriggerCount: executionInfos.TasksToTriggerCount })
        }
        else
            NotificationHelper.showErrorMessage(result.Message)
    }

    getExecutionInfo = async (executionId: string): Promise<ExecutionInfoItem> => {
        let result = await HTTPService.get<JsonResultClass<ExecutionInfoItem>>("Executions/GetExecutionInfo?executionId=" + executionId);
        if (result.Code == 0) {
            return result.Data;
        }
        else
            NotificationHelper.showErrorMessage(result.Message)
    }

    getAssignmentGridData = (filterAssignments: boolean) => {
        let adrNr: string[] = [];

        if (Helper.hasValue(this.state.selectedExecutions) && filterAssignments) {
            for (let index = 0; index < this.state.selectedExecutions.length; index++) {
                let item = this.state.selectedExecutions[index];
                adrNr.push(item.TaskVm.AdrNo);
            }
        }
        /*adrNr = this.state.selectedExecution.TaskVm.AdrNo;*/

        let assignmentItems = [];
        for (let executionInfo of this.state.executionsGridData) {
            for (let assignment of executionInfo.Assignments) {
                if (filterAssignments && adrNr.indexOf(assignment.AdrNr) === -1)
                    continue;
                assignment.ParentExecutionState = executionInfo.ExecutionState;
                assignment.TaskId = executionInfo.TaskVm.Id;
                assignment.TaskNo = executionInfo.TaskVm.TaskNo;
                assignmentItems.push(assignment);
            }
        }
        return assignmentItems;
    }

    getFilterMessage = (filterAssignments: boolean): string => {
        let filterMessage = null;
        if (filterAssignments && this.state.selectedExecutions != null) {
            let message = Helper.getTranslation("WebCRM.Tasks.Executions.AssignmentsToAddress") + ' ';
            let adrNos = [];
            let adrNames = [];
            for (let index = 0; index < this.state.selectedExecutions.length; index++) {
                let item = this.state.selectedExecutions[index];
                if (adrNos.indexOf(item.TaskVm.AdrNo) === -1) {
                    adrNos.push(item.TaskVm.AdrNo);
                    adrNames.push(item.TaskVm.AdrName);
                }
            }
            for (let index = 0; index < adrNos.length; index++) {
                let item = adrNos[index];
                if (index > 0) {
                    message += " und ";
                }
                message += item + ' - ' + adrNames[index];
            }
            filterMessage = message;
        }
        //filterMessage = Helper.getTranslation("WebCRM.Tasks.Executions.AssignmentsToAddress"] + ' ' +
        //    this.state.selectedExecution.TaskVm.AdrNo + ' - ' + this.state.selectedExecution.TaskVm.AdrName;
        else
            filterMessage = Helper.getTranslation("WebCRM.Tasks.Executions.AssignmentsForAllExecutions");
        return filterMessage;
    }

    private finishExecution = async (node: ExecutionInfoItem[]) => {
        let ids = node.map(e => e.ExecutionId);
        let result = await HTTPService.post<JsonResultClass<boolean>>("Executions/FinishExecutions", {
            executionIds: ids,
            comment: this.state.DialogText,
            finishDateTime: this.state.DialogDate
        });
        if (result.Code === 0) {
            this.refreshAll(ids);
            this.setState({ DialogDate: null, DialogText: null });
            if (Helper.hasValue(result.Message)) {
                NotificationHelper.showInfoMessage(result.Message);
            }
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private rescheduleExecution = async (node: ExecutionInfoItem[]) => {
        if (node.length === 1) {
            let result = await HTTPService.post<JsonResultClass<ExecutionInfoItem>>("Executions/RescheduleExecution", {
                executionId: node[0].ExecutionId,
                comment: this.state.DialogText,
                rescheduleDateTime: this.state.DialogDate
            });
            if (result.Code === 0) {
                this.refreshSingleExecution(result.Data);
                this.setState({ DialogDate: null, DialogText: null });
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }
    private cancelExecution = async (node: ExecutionInfoItem[]) => {
        let ids = node.map(e => e.ExecutionId);
        let result = await HTTPService.post<JsonResultClass<boolean>>("Executions/CancelExecutions", {
            executionIds: ids,
            comment: this.state.DialogText
        });
        if (result.Code === 0) {
            this.refreshAll(ids);
            this.setState({ DialogDate: null, DialogText: null });
            if (Helper.hasValue(result.Message)) {
                NotificationHelper.showInfoMessage(result.Message);
            }
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    public deleteExecution = async (node: DeleteExecutionInfo[]) => {
        let isOk = await DialogHelper.confirm(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DeleteExecution.DeleteMessage") + Config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass<string[]>>("Executions/DeleteExecutions", { deleteExecutionInfo: node });
            if (result.Code === 0) {
                result.Data.forEach(item => this.removeExecutionFromGrid(item));
                this.setState({ selectedExecutionInfos: [], selectedExecutions: [] });
                if (Helper.hasValue(result.Message)) {
                    NotificationHelper.showInfoMessage(result.Message, { closeOnHover: true, });
                }
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private resetErrors = async (executions: ExecutionInfoItem[]) => {
        let executionIds = executions.map(x => x.ExecutionId);
        let result = await HTTPService.post<JsonResultClass<ExecutionInfoItem[]>>("Executions/ResetExecutionsErrors", {
            executionIds: executionIds
        });
        if (result.Code === 0) {
            for (let execution of result.Data)
                this.refreshSingleExecution(execution);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private refreshAll = async (ids: string[]) => {
        let resultToRefresh = await this.getExecutionInfos(ids);
        let toDelete = [];
        ids.forEach(id => {
            let index = resultToRefresh.findIndex(item => id === item.ExecutionId);
            if (index !== -1) {
                this.refreshSingleExecution(resultToRefresh[index]);
            }
            else {
                toDelete.push(id);
            }
        });

        toDelete.forEach(item => this.removeExecutionFromGrid(item));
    }

    private generateAssignments = async (executions: ExecutionInfoItem[]) => {
        let ids = executions.map(e => e.ExecutionId);
        let result = await HTTPService.post<JsonResultClass<boolean>>("Executions/GenerateAssignmentItems", {
            executions: executions.map(item => item.ExecutionId)
        });
        if (result.Code === 0) {
            this.refreshAll(ids);
            if (Helper.hasValue(result.Message)) {
                NotificationHelper.showInfoMessage(result.Message);
            }
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    public async getAndRefreshExecution(executionId: string) {
        var executionInfoItem = await this.getExecutionInfo(executionId);
        this.refreshSingleExecution(executionInfoItem);
    }

    private refreshSingleExecution(executionInfoItem: ExecutionInfoItem) {
        var index = this.state.executionsGridData.findIndex(o => o.ExecutionId == executionInfoItem.ExecutionId);
        var copyExecutionGridData = this.state.executionsGridData;
        copyExecutionGridData[index] = executionInfoItem;
        this.setState({ executionsGridData: copyExecutionGridData });
    }

    private removeExecutionFromGrid(executionId: string) {
        var copyExecutionGridData = this.state.executionsGridData.filter(o => o.ExecutionId != executionId);
        var tasksToTriggerCount = this.state.tasksToTriggerCount + 1;
        this.setState({ executionsGridData: copyExecutionGridData, tasksToTriggerCount: tasksToTriggerCount }, this.props.onSetParentState);
    }

    private addNewDeleteInfos(executions: ExecutionInfoItem[], deleteExecutionInfos: DeleteExecutionInfo[]) {
        executions.forEach(item => {
            let index = deleteExecutionInfos.findIndex(i => i.TaskId === item.TaskVm.Id);
            if (index !== -1) {
                deleteExecutionInfos[index].Executions.push({ ExecutionId: item.ExecutionId, ExecutionNo: item.ExecutionNo, IsLastExecution: item.IsLastExecution });
                deleteExecutionInfos[index].Executions.sort((obj1, obj2) => {
                    if (obj1.ExecutionNo < obj2.ExecutionNo)
                        return -1;
                    if (obj1.ExecutionNo > obj2.ExecutionNo)
                        return 1;
                    return 0;
                });
            }
            else {
                let newInfo: DeleteExecutionInfo = { TaskId: item.TaskVm.Id, Executions: [] };
                newInfo.Executions.push({ ExecutionId: item.ExecutionId, ExecutionNo: item.ExecutionNo, IsLastExecution: item.IsLastExecution });
                deleteExecutionInfos.push(newInfo);
            }
        });
    }

    onSelection = (dataItem: ExecutionInfoItem | ExecutionInfoItem[]) => {
        let items: ExecutionInfoItem[] = [];
        let infos: DeleteExecutionInfo[] = [];
        if (dataItem instanceof Array) {
            items = dataItem;
        }
        else {
            if (Helper.hasValue(dataItem)) {
                items.push(dataItem);
            }
        }
        this.addNewDeleteInfos(items, infos);
        if (items.length > 0) {
            let firstItem = items[0]
            let dialogDate = firstItem.ExecutionDate;
            this.setState({ selectedExecutions: items, selectedExecutionInfos: infos, DialogDate: dialogDate });
            this.props.assignmentsGridRef.setState({ filterAssignments: true });
        }

    }


    renderExecutionsGrid = () => {
        const customButtons: Array<GridCustomToolBarButton> = [];
        var executionNotFinishedOrCancelled = false;
        var executionAssignmentCount = 0;
        let executionsScheduledOrPartialScheduled = false;
        let executionsTriggeredOrPreScheduled = false;
        // Hier für alle selektierten Ausführungen finished oder cancelled

        if (this.state.selectedExecutions != null && this.state.selectedExecutions.length > 0) {
            let scheduledOrPartialScheduledItems = this.state.selectedExecutions.filter(item => item.ExecutionState.Value === ExecutionState.Scheduled || item.ExecutionState.Value === ExecutionState.PartialScheduled).length;
            executionsScheduledOrPartialScheduled = scheduledOrPartialScheduledItems === this.state.selectedExecutions.length;

            let notFinishedOrCancelledItems = this.state.selectedExecutions.filter(item => item.ExecutionState.Value !== ExecutionState.Finished && item.ExecutionState.Value !== ExecutionState.Cancelled).length;
            executionNotFinishedOrCancelled = notFinishedOrCancelledItems === this.state.selectedExecutions.length;

            let triggeredOrPreScheduledItems = this.state.selectedExecutions.filter(item => item.ExecutionState.Value === ExecutionState.Triggered || item.ExecutionState.Value === ExecutionState.PreScheduled).length;
            executionsTriggeredOrPreScheduled = triggeredOrPreScheduledItems === this.state.selectedExecutions.length;

            executionAssignmentCount = 0;
            this.state.selectedExecutions.forEach(item => { executionAssignmentCount += item.Assignments.length });
        }

        let buttonEnabled = (this.state.selectedExecutions != null && this.state.selectedExecutions.length > 0 && this.areLastExecutions(this.state.selectedExecutionInfos));

        // auf scheduled und partialscheduled kontrollieren für alle selektierten
        const showFinishExecution = this.props.entity.ExecutionMgmtEnabled && executionsScheduledOrPartialScheduled;
        customButtons.push({
            id: "finishExecution", enabled: showFinishExecution, caption: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.ConfirmAsCompleted"), iconClass: "fas fa-flag-checkered", autoEnabledOnRecordSelected: false
        });

        const showRescheduleExecution = this.props.entity.ExecutionMgmtEnabled && executionAssignmentCount == 0 && executionNotFinishedOrCancelled && this.state.selectedExecutions.length === 1;
        customButtons.push({
            id: "rescheduleExecution", enabled: showRescheduleExecution, caption: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.CustomizeDueDate"), iconClass: "fas fa-reply", autoEnabledOnRecordSelected: false
        });

        const showCancelExecution = this.props.entity.ExecutionMgmtEnabled && executionNotFinishedOrCancelled;
        customButtons.push({
            id: "cancelExecution", enabled: showCancelExecution, caption: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.SkipExecution"), iconClass: "fas fa-times", autoEnabledOnRecordSelected: false
        });

        // auf triggered und prescheduled prüfen für alle selektierten
        const showGenerateAssignment = this.props.entity.ExecutionMgmtEnabled && executionAssignmentCount === 0 && executionsTriggeredOrPreScheduled;

        customButtons.push({
            id: "generateAssignments", enabled: showGenerateAssignment, caption: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.CreateAssignments"), iconClass: "fas fa-random", autoEnabledOnRecordSelected: false
        });

        const showDeleteExecution = this.props.entity.ExecutionMgmtEnabled && buttonEnabled && executionNotFinishedOrCancelled;
        customButtons.push({
            id: "deleteExecution", enabled: showDeleteExecution, caption: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DeleteExecution"), iconClass: "fas fa-trash", autoEnabledOnRecordSelected: false
        });

        const showResetErrors = this.state.selectedExecutions.reduce((acc, curr) => acc + curr.ErrorCount, 0) > 0;
        customButtons.push({
            id: "resetErrors", enabled: showResetErrors, caption: Helper.getTranslation("WebCRM.Tasks.Executions.ResetErrors"), iconClass: "fas fa-broom", autoEnabledOnRecordSelected: false
        });

        const content = <div style={{ height: "400px" }}> <Grid data={this.state.executionsGridData} options={this.executionGridOptions} id="executedTasksGrid"
            onSelectionChanged={this.onSelection} customButtons={customButtons} onClickCustomButton={this.handleClickCustomButtonExecutionsGrid}
        />
        </div>

        return (content);
    }


    handleClickCustomButtonExecutionsGrid = async (id: string) => {
        if (id === "finishExecution") {
            if (this.state.selectedExecutions != null) {
                this.finishDialogRef.openDialog();
            }
        }
        if (id === "rescheduleExecution") {
            this.rescheduleDialogRef.openDialog();
        }
        if (id === "cancelExecution") {
            if (this.state.selectedExecutions != null) {
                this.cancelDialogRef.openDialog()
            }
        }
        if (id === "generateAssignments") {
            if (this.state.selectedExecutions != null) {
                this.generateAssignments(this.state.selectedExecutions);
            }
        }
        if (id === "deleteExecution") {
            this.deleteExecution(this.state.selectedExecutionInfos);
        }
        if (id === "resetErrors") {
            if (this.state.selectedExecutions != null) {
                this.resetErrors(this.state.selectedExecutions);
            }
        }
    }

    private areLastExecutions = (executions: DeleteExecutionInfo[]) => {
        if (executions.length > 0) {
            let result = true;

            for (let i = 0; i < executions.length; i++) {
                let item = executions[i];
                if (result) {
                    if (item.Executions[0].IsLastExecution) {
                        let currentExecNo = item.Executions[0].ExecutionNo;
                        let subResult = true;
                        item.Executions.forEach(exec => {
                            subResult = subResult && exec.ExecutionNo === currentExecNo;
                            currentExecNo++;
                        });
                        result = result && subResult;
                    }
                    else result = false;
                }
                if (!result)
                    break;
            }
            return result;
        }
        return false;
    }

    getExecutionDialog = (label: string, showDatePicker: boolean, onDialogOk: () => void, setDialogRef: (ref) => void, comment: string = null, datePickerText: string = null) => {
        var executionDialogTitle = "";
        //if (Helper.hasValue(this.state.selectedExecution))
        //    executionDialogTitle = this.state.selectedExecution.ExecutionNo.toString() + ' ' + this.state.selectedExecution.WorkPackageTitle;
        return <ExecutionDialog
            title={executionDialogTitle}
            label={label}
            textBoxValue={this.state.DialogText}
            onTextBoxChange={(value: string) => { this.setState({ DialogText: value }) }}
            showDatePicker={showDatePicker}
            dateValue={this.state.DialogDate}
            onDateChange={(value: string) => { this.setState({ DialogDate: value }) }}
            onDialogOk={onDialogOk}
            ref={setDialogRef}
            translations={this.translations}
            comment={comment}
            datePickerText={datePickerText}
        />
    }

    render() {
        const cancelDialog = this.getExecutionDialog(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.SkipExecution"), false, () => this.cancelExecution(this.state.selectedExecutions), (ref) => { this.cancelDialogRef = ref }, Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DeleteAllAssignments"));
        const finishDialog = this.getExecutionDialog(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.ConfirmAsCompleted"), true, () => this.finishExecution(this.state.selectedExecutions), (ref) => { this.finishDialogRef = ref }, null, Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.ConfirmAsCompletedFor"));
        const rescheduleDialog = this.getExecutionDialog(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.CustomizeDueDate"), true, () => this.rescheduleExecution(this.state.selectedExecutions), (ref) => { this.rescheduleDialogRef = ref }, null, Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.CustomizeDueDateTo"));

        if (Helper.hasValue(this.props.assignmentsGridRef))
            this.props.assignmentsGridRef.setState({});

        return (<>
            {this.renderExecutionsGrid()}
            {cancelDialog}
            {finishDialog}
            {rescheduleDialog}
        </>);
    }
}

export interface ExecutionsGridAppProps {
    entity: ExecutionGridEntity;
    context: {
        executionGridOptions?: {};
    }
    gridData?: ExecutionInfoItem[];
    assignmentsGridRef?: AssignmentsGridApp;
    onSetParentState: () => void;
}

export interface ExecutionGridEntity extends Entity {
    ExecutionMgmtEnabled: boolean;
}

export interface ExecutionsAppState {
    selectedExecutions: ExecutionInfoItem[];
    selectedExecutionInfos: DeleteExecutionInfo[];
    executionsGridData: ExecutionInfoItem[];
    tasksToTriggerCount: number;

    DialogDate?: string;
    DialogText?: string;
}

export interface ExecutionInfos {
    ExecutionInfos: ExecutionInfoItem[];
    TasksToTriggerCount: number;
}

export interface DeleteExecutionInfo {
    TaskId: string;
    Executions: DeleteExecutionInfoMap[];
}

export interface DeleteExecutionInfoMap {
    ExecutionId: string;
    ExecutionNo: number;
    IsLastExecution: boolean;
}